export default {
  PARTNER_ID:
    process.env.NODE_ENV === "production"
      ? "us-east-1:4269647a-993f-453e-b7fa-6a6406ccd7aa"
      : "us-east-1:c9f1d88b-0be4-411d-90bb-20c6acf4e777"
};



// WEBPACK FOOTER //
// ./src/GlobalVariables.js